import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import components from './components';
import FastClick from 'fastclick';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import '@/styles/index.scss';
import '@/utils/rem';

Vue.config.productionTip = false;

components.map(components => {
Vue.component(components.name, components);
});

Vue.use(AlertPlugin);
Vue.use(ToastPlugin);

FastClick.attach(document.body);

FastClick.prototype.focus = function (targetElement) {
targetElement.focus();
};

router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title;
}
next();

if (['industry', 'problem', 'problemDetail', 'home'].indexOf(to.name) !== -1) {
next();
} else {
store
.dispatch('getSecrecy')
.then(res => {
if (['step01', 'step02', 'step03', 'success', 'industry'].indexOf(to.name) !== -1) {

store.dispatch('initUser');
}

next({ ...to, replace: true });
})
.catch(() => {
next('/home');
});
}
});

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js